import styled from '@emotion/styled';

const Loader = styled.div`
  font-size: 50px;
  width: 1em;
  height: 1em;
  position: relative;

  @keyframes fade {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;
const LoaderWheel = styled.span`
  display: block;
  position: absolute;
  width: 0.1em;
  height: 0.3em;
  background: #6d3ad8;
  border-radius: 0.05em;
  left: 50%;
  top: 50%;
  transform-origin: left top;
  opacity: 0;
  animation: fade 0.8s linear infinite;

  &:nth-child(1) {
    transform: rotate(0deg) translate(-50%, 70%);
  }
  &:nth-child(2) {
    transform: rotate(45deg) translate(-50%, 70%);
  }
  &:nth-child(3) {
    transform: rotate(90deg) translate(-50%, 70%);
  }
  &:nth-child(4) {
    transform: rotate(135deg) translate(-50%, 70%);
  }
  &:nth-child(5) {
    transform: rotate(180deg) translate(-50%, 70%);
  }
  &:nth-child(6) {
    transform: rotate(225deg) translate(-50%, 70%);
  }
  &:nth-child(7) {
    transform: rotate(270deg) translate(-50%, 70%);
  }
  &:nth-child(8) {
    transform: rotate(315deg) translate(-50%, 70%);
  }

  &:nth-child(2) {
    animation-delay: 0.1s;
  }
  &:nth-child(3) {
    animation-delay: 0.15s;
  }
  &:nth-child(4) {
    animation-delay: 0.25s;
  }
  &:nth-child(5) {
    animation-delay: 0.35s;
  }
  &:nth-child(6) {
    animation-delay: 0.45s;
  }
  &:nth-child(7) {
    animation-delay: 0.55s;
  }
  &:nth-child(8) {
    animation-delay: 0.65s;
  }
`;

export { Loader, LoaderWheel };
